import { useState } from 'react';

const FormInput = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  required = false,
  as = 'input',
  rows = 4,
  error
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const baseClasses = `
    w-full px-4 py-3 rounded-xl border-2 transition-all duration-300
    bg-white dark:bg-neutral-800
    border-neutral-200 dark:border-neutral-700
    text-primary dark:text-white
    placeholder-neutral-400 dark:placeholder-neutral-500
    focus:outline-none
    hover:border-primary/50 dark:hover:border-accent/50
  `;

  const focusClasses = isFocused 
    ? 'border-accent ring-2 ring-accent/20 transform scale-[1.01]' 
    : '';

  const errorClasses = error ? 'border-red-500 focus:border-red-500' : '';

  return (
    <div className="space-y-2 animate-fade-in-up">
      <label 
        htmlFor={name} 
        className={`block text-sm font-semibold transition-all duration-300 ${
          isFocused || value
            ? 'text-accent scale-95 origin-left'
            : 'text-primary dark:text-white'
        }`}
      >
        {label}
        {required && <span className="text-accent ml-1">*</span>}
      </label>
      
      {as === 'textarea' ? (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          rows={rows}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={`${baseClasses} ${focusClasses} ${errorClasses} resize-none min-h-[120px] hover-lift`}
        />
      ) : (
        <input
          id={name}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={`${baseClasses} ${focusClasses} ${errorClasses} hover-lift`}
        />
      )}
      
      {/* Animated underline for focus */}
      <div className={`h-0.5 bg-accent transition-all duration-300 ${
        isFocused ? 'w-full opacity-100' : 'w-0 opacity-0'
      }`} />

      {/* Error animation */}
      {error && (
        <div className="text-sm text-red-500 animate-fade-in-up flex items-center gap-2">
          <span className="text-lg">⚠</span>
          {error}
        </div>
      )}
    </div>
  );
};

export default FormInput;
